import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist} from "../../../Services/BrowserDatabaseFunctions";


export function addEventAttendees(_event_id, _new_attendees) {
    return openDb('pa', 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction('Events', 'readwrite');
            const dataStore = tx.objectStore('Events');

            // Get the events array by key "Events"
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                //go through each of the new Attendees and add if doesn't exist
                //otherwise only update using deep

                // Ensure attendees array exists
                const attendees = Array.isArray(event.attendees)
                    ? [...event.attendees]
                    : [];

                // Go through each of the new attendees
                (_new_attendees || []).forEach(newAtt => {
                    if (!newAtt) return;

                    const existingIndex = attendees.findIndex(
                        att => att.id && newAtt.id && att.id === newAtt.id
                    );

                    if (existingIndex === -1) {
                        // Doesn't exist → add
                        attendees.push(newAtt);
                    }
                });

                // write back
                event.attendees = attendees;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                // Put the updated events array back into the object store
                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(`Attendees for Event with ID ${_event_id} added/updated successfully.`);
                    return true;
                });

            });
        }).catch(function (error) {
            console.error("An error occurred:", error);
            throw error; // Re-throw the error to be caught by the caller
        });
}

export function updateEventAttendee(_event_id, _attendee_id, _image, _avatar,
                                    fname, lname, nickname, address, city, state,
                                    zip, country, phone_prefix, phone, email, dob,
                                    language, preferred_airport, last_mod) {
    return openDb('pa', 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction('Events', 'readwrite');
            const dataStore = tx.objectStore('Events');

            // Get the event
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                    // Ensure attendees array exists and clone it
                    const attendees = Array.isArray(event.attendees)
                        ? [...event.attendees] // Immutable update step 2: Clone the attendees array
                        : [];

                    // --- Define the new and updated attendee fields ---
                    const newAttendeeFields = {
                        id: _attendee_id, // Key field
                        image: _image,
                        avatar: _avatar,
                        fname: fname,
                        lname: lname,
                        nickname: nickname,
                        address: address,
                        city: city,
                        state: state,
                        zip: zip,
                        country: country,
                        phone_prefix: phone_prefix,
                        phone: phone,
                        email: email,
                        dob: dob,
                        language: language,
                        preferred_airport: preferred_airport,
                        last_mod: last_mod
                    };


                    // --- Update the specific attendee within the array ---
                    const attendeeIndex = attendees.findIndex(att => att.id === _attendee_id);

                    if (attendeeIndex !== -1) {
                        // UPDATE: Attendee found, merge existing fields with new fields
                        // This prevents accidentally deleting fields not passed in the function signature.
                        const existingAttendee = attendees[attendeeIndex];

                        // Use Object.assign or spread for shallow merge
                        const mergedAttendee = Object.assign({}, existingAttendee, newAttendeeFields);

                        attendees[attendeeIndex] = mergedAttendee;
                    } else {
                        // ADD: Attendee not found, add the new attendee to the array
                        attendees.push(newAttendeeFields);
                    }


                    // write back the new array to the event object
                    event.attendees = attendees;


                // sanitize to avoid DataCloneError (functions, weird objects, etc.)
                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                        console.log(`Attendee for Event with ID ${_event_id} added/updated successfully.`);
                        return true;
                    });

            });
        }).catch(function (error) {
            console.error("An error occurred:", error);
            // Ensure the transaction is aborted if it hasn't committed yet
            throw error;
        });
}

export function updateEventAttendeeRole(_event_id, _attendee_id, _role) {
    const normalizedRole = _role.toLowerCase();
    const isPlanner = normalizedRole === 'planner';

    return openDb('pa', 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction('Events', 'readwrite');
            const dataStore = tx.objectStore('Events');

            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // 2. Update the Attendees Array
                const updatedAttendees = (event.attendees || []).map(att => {
                    if (att.id === _attendee_id) {
                        return {
                            ...att,
                            role: normalizedRole,
                            planner: isPlanner
                        };
                    }
                    return att;
                });

                // 3. Re-derive the Host Array (Match the logic in your UI)
                const updatedHost = updatedAttendees
                    .filter(att => att.role === 'admin' || att.role === 'master_admin')
                    .map(att => att.id);

                // 4. Apply changes back to the cloned event
                event.attendees = updatedAttendees;
                event.host = updatedHost;

                // sanitize to avoid DataCloneError (functions, weird objects, etc.)
                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(`Role for Attendee ${_attendee_id} updated in IndexedDB.`);
                    return true;
                });
            });
        }).catch(err => {
            console.error("DB Error updating role:", err);
            throw err;
        });
}

export function updateEventAttendeeBudget(_event_id, _attendee_id, _budget) {
    return openDb('pa', 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction('Events', 'readwrite');
            const dataStore = tx.objectStore('Events');

            // Get the event
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                if (Array.isArray(event.attendees)) {
                    // 3. Map through attendees and inject the new flat budget payload
                    event.attendees = event.attendees.map(att => {
                        if (String(att.id) === String(_attendee_id)) {
                            return {
                                ...att,
                                budget: _budget
                            };
                        }
                        return att;
                    });
                }

                // 4. Sanitize to avoid DataCloneError (removes functions, DOM nodes, etc.)
                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                // 5. Commit write changes back down to local storage
                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(`IndexedDB local cache updated for event ${_event_id}. Attendee budget synced.`);
                    return true;
                });

            });
        }).catch(function (error) {
            console.error("An error occurred:", error);
            // Ensure the transaction is aborted if it hasn't committed yet
            throw error;
        });
}




const isPlainObject = (v) =>
    v !== null && typeof v === 'object' && Object.getPrototypeOf(v) === Object.prototype;

function deepEqualJSON(a, b) {
    if (a === b) return true;
    if (a === null || b === null) return a === b;
    const ta = typeof a, tb = typeof b;
    if (ta !== tb) return false;

    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) if (!deepEqualJSON(a[i], b[i])) return false;
        return true;
    }

    if (isPlainObject(a) && isPlainObject(b)) {
        const ak = Object.keys(a), bk = Object.keys(b);
        if (ak.length !== bk.length) return false;
        for (const k of ak) {
            if (!Object.prototype.hasOwnProperty.call(b, k)) return false;
            if (!deepEqualJSON(a[k], b[k])) return false;
        }
        return true;
    }

    // primitives (number/string/boolean/undefined) or mismatched structures
    return false;
}

/**
 * Deep merge only for keys present in `patch`.
 * - Plain objects are merged recursively.
 * - Arrays are replaced wholesale.
 * - Primitives are overwritten.
 * Returns { merged, changed }.
 */
function mergeChanged(base = {}, patch = {}) {
    if (!isPlainObject(base) || !isPlainObject(patch)) {
        // Fallback: replace when not both plain objects
        return {
            merged: deepEqualJSON(base, patch) ? base : patch,
            changed: !deepEqualJSON(base, patch),
        };
    }

    let changed = false;
    const out = { ...base };

    for (const [k, pv] of Object.entries(patch)) {
        const bv = base[k];

        if (Array.isArray(pv)) {
            if (!deepEqualJSON(bv, pv)) {
                out[k] = pv.slice(); // replace array
                changed = true;
            }
            continue;
        }

        if (isPlainObject(pv) && isPlainObject(bv)) {
            const inner = mergeChanged(bv, pv);
            if (inner.changed) {
                out[k] = inner.merged;
                changed = true;
            }
            continue;
        }

        // primitives or differing shapes
        if (!deepEqualJSON(bv, pv)) {
            out[k] = pv;
            changed = true;
        }
    }

    return { merged: out, changed };
}